module.exports = __webpack_public_path__ + "img/educator-full-curriculum.91ffbe6b.png";